/**
 * Created by mnaughton on 10/22/2015.
 */

/**
 * In charge of displaying whatever is displayed by "context".
 * @module app/views/map/MapDisplayView
 * @alias MapDisplayView
 */
import WindowView from "core/views/WindowView";
import _ from "underscore";
import ViewHelper from "app/views/map/helpers/ViewHelper";
import ModelUtil from "@HBKEngineering/model-util";
import mapContext from "app/views/map/MapContext";

export default WindowView.extend({
  initialize: function (options) {
    WindowView.prototype.initialize.apply(this, arguments);

    mapContext.on("change:display", this.showModel, this);

    this._showing = false;
  },

  render: function () {
    WindowView.prototype.render.apply(this, arguments);

    this.showModel(false, true);
  },

  className: WindowView.prototype.className + " map-display-view",

  /**
   * Shows the given model.
   * @param model An object to display. A different view is selected based on which model is passed.
   * @param {Boolean} [forceUpdate] True to force the window to completely re-update child views. Otherwise false.
   */
  showModel: function (model, forceUpdate) {
    var updateDisplay = true;

    if (this._showing == model && this._showingId == ModelUtil.idFor(model)) {
      updateDisplay = false;
    } else {
      this._showing = model;
      this._showingId = ModelUtil.idFor(model);
    }

    updateDisplay = updateDisplay || forceUpdate;

    if (!updateDisplay) {
      //just refresh if they're the same
      this.setContent(this.contentView.$el);
      this.header.setTitle(this.contentView.getTitle());
      this.setFooter(this.contentView.getFooter());
      this.contentView.refreshControls();

      this.refresh();
    } else {
      var view;

      view = ViewHelper.getViewForModel(model);

      var self = this;

      var clearToolbar = function clearToolbar() {
        self.clearControls();
      };

      var refreshWindow = function refreshWindow() {
        self.setContent(self.contentView.$el);

        self.header.setTitle(self.contentView.getTitle());
        self.setFooter(self.contentView.getFooter());

        _.each(self.contentView.getControls(), function (control) {
          self.header.getRightControlBar().prepend(control);
        });

        self.refresh();

        view.off(
          "title-changed footer-changed controls-changed",
          refreshWindow
        );
        view.on("title-changed footer-changed controls-changed", refreshWindow);

        view.off("controls-cleared", clearToolbar);
        view.on("controls-cleared", clearToolbar);
      };

      self.contentView = view;
      clearToolbar();
      refreshWindow();
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/MapDisplayView.js
// module id = 954
// module chunks = 1